import { ComponentProps, FC, useState } from 'react'
import { IconButton, Tooltip } from '@chakra-ui/react'
import { copyToClipboard } from '../utils'
import { FiCopy } from 'react-icons/fi'

type Props = ComponentProps<typeof IconButton> & {
    copyText: string
}

export const CopyIconButton: FC<Props> = ({ copyText, tooltip='Copy to Clipboard', ...rest }) => {
    const [copied, setCopied] = useState(false)

    const handleCopied = () => {
        copyToClipboard(copyText)
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 1000)
    }

    return <Tooltip label={copied ? 'Copied!' : tooltip} openDelay={500} closeOnClick={false}>
        <IconButton
            onClick={() => {
                
                handleCopied()
            }}
            icon={<FiCopy/>}
            {...rest}
        />
    </Tooltip>   
}
